
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.446 1A6.561 6.561 0 0123 7.554v8.892A6.561 6.561 0 0116.446 23H7.554A6.561 6.561 0 011 16.446V7.554A6.561 6.561 0 017.554 1zM6.93 15.906h-.141a.496.496 0 00-.425.236l-.897 1.463c-.236.424-.094.99.33 1.227a.927.927 0 001.274-.283l1.086-1.888c-.142-.378-.566-.755-1.227-.755zm6.465-7.22s-.189.142-.472.614a2.312 2.312 0 00.047 2.218l1.369 2.312 1.038 1.793 1.698 2.878a.927.927 0 00.803.425c.188 0 .33-.047.471-.142.425-.236.52-.802.284-1.227l-1.133-1.934h1.557c.52 0 .944-.425.944-.944a.965.965 0 00-.944-.85h-2.642zm.519-3.539c-.425-.283-1.038-.141-1.274.283l-.566.991-.567-.99c-.283-.425-.849-.567-1.274-.284-.424.283-.519.802-.283 1.227l1.085 1.793-3.303 5.663H4.947c-.519 0-.943.377-.943.85-.048.518.377.943.896.943h9.673s.048-.095 0-.283c0-.33-.094-.52-.283-.85v-.047c-.188-.33-.707-.566-1.132-.566h-3.35l2.265-3.87 1.038-1.793 1.085-1.84c.236-.425.142-.944-.283-1.227z","fill":"#1C9BF7"}})])
          )
        }
      }
    